<template>
  <div>
    <div class="row mb-2">
      <div class="col-lg-1">
        <label class="pull-left text-text-primary">{{ $t("b2c.texts.limit") }}</label>
        <select class="form-control" :key="pagesize" v-model="pagesize">
          <option :value="10">10</option>
          <option :value="25">25</option>
          <option :value="50">50</option>
          <option :value="100">100</option>
        </select>
      </div>

      <div style="position: relative" class="col-lg-4 text-text-primary">
        <invoicer-select-input
          :customers="invoicers"
          :selected="selectedInvoicer"
          v-on:selectInvoicer="selectedInvoicer = $event"
        ></invoicer-select-input>
      </div>
      <div class="col-lg-7">
        <div
          style="height: 100%"
          class="d-flex flex-row-reverse align-items-end"
        >
          <button
            :disabled="selectedInvoices < 1"
            class="btn btn-button-success"
            @click="deleteInvoices"
          >
            {{ $t("b2c.delete") }} {{ selectedInvoices.length }}
          </button>
          <p class="mr-2 mb-1 text-text-primary">
            {{ $t("b2c.invoices", { count: count }, count) }}
          </p>
        </div>
      </div>
    </div>
    <v-server-table
      id="invoice-table"
      ref="invoiceTable"
      :columns="columns"
      :options="options"
    >
      <!--       <template slot="afterLimit"> -->

      <!--       </template> -->
      <template slot="afterFilters">
        <div v-if="loading" class="slider">
          <div class="line"></div>
          <div class="subline inc"></div>
          <div class="subline dec"></div>
        </div>
      </template>
      <template slot="select" slot-scope="props">
        <input
          type="checkbox"
          class="form-control form-control-sm"
          style="width: 20px; margin: auto"
          :value="props.row"
          v-model="selectedInvoices"
        />
      </template>
      <template slot="name" slot-scope="props">
        <router-link
          v-if="props.row.idInvoicee"
          class="invoicee-link"
          :to="{
            name: 'invoicee',
            params: { invoiceeId: props.row.idInvoicee, id: props.row.apixId },
          }"
          >{{ props.row.name }}</router-link
        >
        <div v-else>{{ props.row.name }}</div>
      </template>
      <template slot="createdAt" slot-scope="props">{{
        props.row.createdAt | formatDate
      }}</template>
      <template slot="updatedAt" slot-scope="props">{{
        props.row.updatedAt | formatDate
      }}</template>
    </v-server-table>
    <div ref="wrapper" class="wrapper1">
      <div :style="widthObj" class="div1"></div>
    </div>
    <modal :loading="loading"></modal>
  </div>
</template>

<script>
import TextFilter from "../components/suppliers/TextFilter";
import TextHeader from "../components/suppliers/TextHeader";
import InvoicerSelectInput from "../components/common/InvoicerSelectInput";
import { Event as event } from "vue-tables-2";
import moment from "moment";
import Modal from "../components/common/Modal";

export default {
  created: function () {
    this.$store.dispatch("listInvoicers").then((data) => {
      this.invoicers = data;
      if (data.length > 0) {
        this.selectedInvoicer = data[0];
      }
    });
    const pagesize = localStorage.getItem("pagesize");
    if (pagesize) {
      this.pagesize = pagesize;
      this.options.perPage = pagesize;
    }
  },
  mounted: function () {
    let table = this.$refs.invoiceTable.$el.children[1];
    let wrapper1 = this.$refs.wrapper;
    wrapper1.onscroll = function () {
      table.scrollLeft = wrapper1.scrollLeft;
    };
    table.onscroll = function () {
      wrapper1.scrollLeft = table.scrollLeft;
    };
    this.windowWidth = window.innerWidth;

    this.$watch("pagesize", function (val) {
      this.$refs.invoiceTable.setLimit(val);
      localStorage.setItem("pagesize", val);
    });
    function top(e) {
      e = window.$(e);
      return e.offset().top;
    }

    function bottom(e) {
      e = window.$(e);
      return e.offset().top + e.height();
    }
    const windowListener = () => (this.windowWidth = window.innerWidth);
    const scrollListener = () => {
      if (this.displayScroll) {
        window.$(wrapper1).show();
        let topT = top(table);
        let topW = top(wrapper1);
        let botT = bottom(table);
        let botW = bottom(wrapper1);
        if (topT < topW && botT > botW) {
          window.$(wrapper1).show();
        } else {
          window.$(wrapper1).hide();
        }
      }
    };
    this.scrollListener = scrollListener;
    this.windowListener = windowListener;
    this.$nextTick(() => {
      window.addEventListener("resize", windowListener);
      window.addEventListener("scroll", scrollListener);
    });
    event.$on("vue-tables.limit", (e) => {
      localStorage.setItem("pagesize", e);
    });
    event.$on("vue-tables.loading", (data) => {
      this.loading = true;
    });
    event.$on("vue-tables.loaded", (data) => {
      this.loading = false;
    });
    setTimeout(() => {
      this.displayScroll =
        this.$refs.invoiceTable.$el.children[1].scrollWidth >
        this.$refs.invoiceTable.$el.children[1].clientWidth;
      this.widthObj = {
        width: this.$refs.invoiceTable.$el.children[1].scrollWidth + 30 + "px",
      };
    }, 1000);
  },
  beforeDestroy: function () {
    window.removeEventListener("resize", this.windowListener);
    window.removeEventListener("scroll", this.scrollListener);
    let table = this.$refs.invoiceTable.$el.children[1];
    let wrapper1 = this.$refs.wrapper;
    table.onscroll = null;
    wrapper1.onscroll = null;
  },
  components: {
    Modal,
    InvoicerSelectInput,
    //  EditCell
  },
  filters: {
    formatDate: function (date) {
      if (date) {
        date = moment(date).format("HH:mm DD.MM.YYYY");
        return date;
      }
      return "";
    },
  },
  watch: {
    windowWidth: function (val) {
      this.displayScroll =
        this.$refs.invoiceTable.$el.children[1].scrollWidth >
        this.$refs.invoiceTable.$el.children[1].clientWidth;
      this.widthObj = {
        width: this.$refs.invoiceTable.$el.children[1].scrollWidth + 30 + "px",
      };
    },
    pagesize: function (val) {
      this.$refs.invoiceTable.setLimit(val);
      localStorage.setItem("pagesize", val);
    },
    $route: function (to, from) {
      if (to.name === "invoices") {
        this.$refs.invoiceTable.getData();
      }
    },
    selectedInvoicer: function () {
      this.$refs.invoiceTable.getData();
    },
  },
  data() {
    let self = this;
    return {
      invoicers: [],
      selectedInvoicer: null,
      count: 0,
      pagesize: 25,
      loading: false,
      displayScroll: true,
      tableScrollVisible: false,
      widthObj: "1800px",
      windowListener: null,
      scrollListener: null,
      windowWidth: null,
      filters: {
        apixId: "",
        name: "",
        serviceCode: "",
        ibanBic: "",
        ibanAddress: "",
        language: "",
      },

      orderBy: {
        column: "name",
        isAscending: true,
      },

      selectedInvoices: [],
      editableTextFields: [],
      options: {
        orderBy: {
          column: "name",
        },
        skin: "supplier-table",
        texts: {
          count: this.$t("b2c.texts.count"),
          filter: this.$t("b2c.texts.filter"),
          filterPlaceholder: this.$t("b2c.texts.filterPlaceholder"),
          limit: self.$t("b2c.texts.limit"),
          page: this.$t("b2c.texts.page"),
          noResults: this.$t("b2c.texts.noResults"),
          filterBy: this.$t("b2c.texts.filterBy"),
          loading: this.$t("b2c.texts.loading"),
          defaultOption: this.$t("b2c.texts.defaultOptions"),
          columns: this.$t("b2c.texts.columns"),
        },
        requestFunction: function (query) {
          return self.createQuery(query);
        },
        sortIcon: {
          is: "fa-minus",
          base: "fa",
          up: "fa-arrow-up",
          down: "fa-arrow-down",
        },
        uniqueKey: "id",
        pagination: {
          dropdown: false,
          chunk: 5,
        },
        perPage: 25,
        perPageValue: [10, 25, 50, 100],
        clientMultiSorting: true,
        compileTemplates: true,
        columnsClasses: {
          address1: "address-col",
          updatedAt: "date-col",
          createdAt: "date-col",
          street2: "address-col",
          name: "name-col",
          businessId: "bid-col",
          postalCode: "",
          status: "status-col",
          apixId: "id-col",
          city: "address-col",
          postCode: "address-col",
          country: "langugage-col",
          serviceCode: "id-col",
          language: "langugage-col",
        },

        filterable: true,
        filterByColumn: true,
        sortable: [],
        headings: {
          select: function (h) {
            return h("input", {
              attrs: {
                type: "checkbox",
                id: "selectAllCheckbox",
                class: "form-control",
                style: "min-width:30px",
              },
              on: {
                click: (e) => {
                  this.selectAll(e.srcElement.checked);
                },
              },
              ref: "selectAllCheckbox",
            });
          },
          updatedAt: self.headerFilter("updatedAt", TextHeader),
          createdAt: self.headerFilter("createdAt", TextHeader),
          apixId: self.headerFilter("apixId", TextFilter),
          invoiceReasonCode: self.headerFilter("invoiceReasonCode", TextHeader),
          name: self.headerFilter("name", TextFilter),
          name2: self.headerFilter("name2", TextFilter),
          address1: self.headerFilter("address1", TextFilter),
          address2: self.headerFilter("address2", TextFilter),
          city: self.headerFilter("city", TextFilter),
          postCode: self.headerFilter("postCode", TextFilter),
          country: self.headerFilter("country", TextFilter),
          ibanAddress: self.headerFilter("ibanAddress", TextFilter),
          ibanBic: self.headerFilter("ibanBic", TextFilter),
          serviceCode: self.headerFilter("serviceCode", TextFilter),
          language: self.headerFilter("language", TextFilter),
        },
      },
    };
  },
  computed: {
    columns: function () {
      return [
        "select",
        "apixId",
        "createdAt",
        "updatedAt",
        "name",
        "ibanAddress",
        "ibanBic",
        "serviceCode",
        "language",
      ];
    },
    showGhostScroll: function () {
      return this.displayScroll;
    },
  },

  methods: {
    selectAll(checked) {
      if (checked) {
        this.selectedInvoices = this.$refs.invoiceTable.data;
      } else {
        this.selectedInvoices = [];
      }
    },
    deleteInvoices: function () {
      this.$openModal({
        type: "confirm",
        text: this.$t("b2c.confirmRemove", {
          count: this.selectedInvoices.length,
        }),
        title: this.$t("modal.remove"),
        callback: async () => {
          try {
            this.loading = true;
            let res = await this.$store.dispatch("deleteInvoices", {
              id: this.selectedInvoices.map((i) => i.id),
            });

            if (res.success) {
              this.$notify({
                text: this.$t("b2c.removeSuccessful", {
                  count: this.selectedInvoices.length,
                }),
                type: "success",
                duration: 3000,
              });
              this.$refs.invoiceTable.getData();
              this.selectedInvoices = [];
            }
          } catch (error) {
            console.log(error);
            this.$notify({
              text: this.$t("b2c.errorRemoving"),
              type: "error",
              duration: 3000,
            });
          } finally {
            this.$closeModal();
            this.loading = false;
          }
        },
      });
    },

    createQuery: async function (query) {
      try {
        let res = await this.$store.dispatch("listB2C", {
          ...this.filters,
          idInvoicer:
            (this.selectedInvoicer && this.selectedInvoicer.idInvoicer) || "",
          page: query.page,
          limit: query.limit,
          orderBy: this.orderBy.column,
          ascending: this.orderBy.isAscending,
        });
        this.count = res.count;
        return res;
      } catch (err) {
        console.log(err);
        return err;
      }
    },
    debounceSearch: function (query) {
      if (this.filterTimer) clearTimeout(this.filterTimer);
      this.filterTimer = setTimeout(() => {
        this.$refs.invoiceTable.setFilter(query);
      }, 1000);
    },

    headerFilter: function (columnName, filter, values) {
      return function (h) {
        return h(filter, {
          props: {
            column: columnName,
            options: values,
            filterVal: this.filters[columnName],
            isAscending:
              this.orderBy.column === columnName
                ? this.orderBy.isAscending
                : null,
          },
          on: {
            updateFilter: (e) => {
              this.filters[columnName] = e;
              this.debounceSearch({ [columnName]: e });
            },
            updateOrderBy: (e) => {
              this.orderBy = e;
              this.setOrder(e);
            },
            updateValidation: (e) => {},
          },
        });
      };
    },
    setOrder: function ({ column, isAscending }) {
      this.$refs.invoiceTable.setOrder(column, isAscending);
    },
  },
};
</script>

<style scoped>
.wrapper1 {
  display: block;
  overflow-x: scroll;
  position: fixed;
  width: 100%;
  bottom: 0px;
}
.div1 {
  height: 20px;
}

.status-list {
  margin: auto;
  display: flex;
  flex-direction: row;
  list-style: none;
  margin-bottom: 0;
  font-size: 20px;
}
.btn-text:hover {
  text-decoration: underline;
}
.btn-text {
  padding-top: 0;
  padding-bottom: 0;
  font-size: 20px;
}
.nav-tabs {
  border-bottom: 2px solid #468e9e;
}
.nav-item {
  width: 20%;
}
.nav-link {
  font-size: 1.5rem;
  cursor: pointer;
  border-bottom: 2px solid #468e9e;
}
.nav-link.active {
  color: #fff;
  background-color: #367b8b;
  border: 1px solid;
  border-bottom: none;
  border-color: #468e9e #468e9e #468e9e;

  border-bottom: solid 2px rgb(255, 115, 0);
}

.nav-link:not(.active):hover {
  color: #fff;
  background-color: #367b8b;
  border: none;
  border: 1px solid transparent;
}
@media screen and (max-width: 768px) {
  .nav-link {
    height: 100%;
  }
}
@media screen and (max-width: 425px) {
  .nav-link {
    font-size: 0.7rem;
  }
}
@media screen and (max-width: 320px) {
  .nav-link {
    font-size: 0.7rem;
  }
}
</style>
<style>
.invoicee-link {
  color: #37727e;
}
.invoicee-link:hover {
  color: #37727e;
}
table {
  color: #0B0B14;
  width: 100%;
}
input[type="checkbox"] {
  accent-color: #006366;
}

.bid-col {
  min-width: 100px;
  text-align: left;
  padding-left: 5px !important;
}
.status-col {
  max-width: 100px;
}
.address-col {
  min-width: 120px;
}
.date-col {
  min-width: 160px;
}
.id-col {
  min-width: 145px;
}
.langugage-col {
  width: 100px;
  min-width: 100px;
}
.invoice-table {
  border: 1px solid rgba(0, 0, 0, 0.2);
}

.invoice-table thead {
  color: #fff;
}

.circle {
  margin: auto;
  border-radius: 50%;
  width: 1.5em;
  height: 1.5em;

  cursor: pointer;
}

.circle_green {
  background-color: green;
}

.circle_yellow {
  background-color: rgb(255, 196, 0);
}

.circle_red {
  background-color: red;
}

.circle_gray {
  background-color: gray;
}

.slider {
  position: absolute;
  width: 97%;
  height: 5px;
  overflow-x: hidden;
}

.line {
  position: absolute;
  opacity: 0.4;
  background: #4a8df8;
  width: 100%;
  height: 5px;
}

.subline {
  position: absolute;
  background: #4a8df8;
  height: 5px;
}
.inc {
  animation: increase 2s infinite;
}
.dec {
  animation: decrease 2s 0.5s infinite;
}

@keyframes increase {
  from {
    left: -5%;
    width: 5%;
  }
  to {
    left: 130%;
    width: 100%;
  }
}
@keyframes decrease {
  from {
    left: -80%;
    width: 80%;
  }
  to {
    left: 110%;
    width: 10%;
  }
}

.invoice-table td,
th {
  border-left: 1px solid #E0E0E0;
  padding: 8px;
}
.invoice-table td:first-child,
th:first-child {
  border-left: none;
}
.table > thead > tr > th {
  padding: 10px 0px 0px 0px;
}
.VueTables__child-row > td {
  padding: 0 !important;
}
.VuePagination .page-item:last-child,
.page-item:first-child {
  display: none;
}
.VueTables__child-row-toggler {
  width: 16px;
  height: 16px;
  line-height: 16px;
  display: block;
  margin: auto;
  text-align: center;
}

.VueTables__child-row-toggler--closed::before {
  font-family: FontAwesome;
  content: "\f067";
  /* content: "+"; */
  cursor: pointer;
}

.VueTables__child-row-toggler--open::before {
  font-family: FontAwesome;
  content: "\f068";
  cursor: pointer;
}
.invoice-table th:first-child::after {
}

/* .header:focus-within > label {
  top: -10px;
} */
.VueTables__sortable {
  position: relative;
}

/* .table-responsive {
  overflow: visible !important;
}
 */
.page-navigator > button {
  margin: 0;
  padding: 15px;
  border-radius: 0px;
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  overflow: hidden;

  transition: height 0.3s linear;
}
.slide-fade-leave-active {
  overflow: hidden;

  transition: height 0.3s linear;
}
.slide-fade-enter-to,
.slide-fade-leave {
  overflow: hidden;
  height: 450px;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  height: 0px;
}

.dropdown {
  margin-top: 1.5em;
  float: left;
}

.VuePagination .page-link {
  color: #FFFFFF;
  background-color: #004A4D;
  border: none;
}
.VuePagination .page-link:focus {
  outline: #96cad4 1px solid;
  box-shadow: none;
}

.VuePagination .page-link:hover {
  color: #0B0B14;
  background-color: rgba(0, 0, 0, 0.05);
}

.VuePagination .page-item.active .page-link {
  background-color: #D1F9FA;
  color: #0B0B14;
  border: none;
}

.VuePagination .page-item.disabled .page-link {
  background-color: #FFFFFF;
}
.VuePagination__count {
  display: none;
}

.opener-icon {
  width: 35px;
  cursor: pointer;
  font-size: 35px !important;
}

.loading-dots:after {
  content: " .";
  font-size: 20px;
  animation: dots 1s steps(5, end) infinite;
}

.VueTables__filters-row {
  display: none;
}
.VueTables__limit.pull-right {
  float: none;
}
.VueTables__limit-field {
  display: none;
}
.supplier-table-wrapper {
  margin-top: 1em;
}
.supplier-table {
  background: #fff;
  border: 1px solid #E0E0E0;
}
.supplier-table td {
  border: 1px solid #E0E0E0;
  padding: 2px 4px 2px 4px;
}

.supplier-table tr:nth-child(odd) {
  background: #E0E0E0;
}
.supplier-table thead > tr:first-child {
  background: #fff;
}
td {
  position: relative;
}

.suppliers-actions select {
  border-radius: 0 !important;
}

.suppliers-actions button {
  border-radius: 0 !important;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.dropdown-menu-item > label {
  float: left;
  clear: both;
  cursor: pointer;
}
.dropdown-menu-item > label:hover {
  color: rgba(0, 0, 0, 0.5);
}

@keyframes dots {
  0%,
  20% {
    color: rgba(0, 0, 0, 0);
    text-shadow: 0.25em 0 0 rgba(0, 0, 0, 0), 0.5em 0 0 rgba(0, 0, 0, 0);
  }
  40% {
    color: white;
    text-shadow: 0.25em 0 0 rgba(0, 0, 0, 0), 0.5em 0 0 rgba(0, 0, 0, 0);
  }
  60% {
    text-shadow: 0.25em 0 0 white, 0.5em 0 0 rgba(0, 0, 0, 0);
  }
  80%,
  100% {
    text-shadow: 0.25em 0 0 white, 0.5em 0 0 white;
  }
}

@media screen and (max-width: 1025px) {
  .invoice-table th:first-child::after {
    font-size: 14px;
  }
}
@media screen and (max-width: 425px) {
  .status-list .btn-text {
    font-size: 14px;
  }
  .status-list {
    padding-left: 0;
  }
  .invoice-table td,
  th {
    padding: 2px;
    font-size: 14px;
  }
}
</style>
